import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { MainApp } from './MainApp';
import { Layout, AnalysisView, HistoryPage, SettingsPage, ImplementationPage } from './components';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<MainApp />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/implementation" element={<ImplementationPage />} />
          <Route path="/analysis/:id" element={<AnalysisView />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
